import Filter from '../../controllers/filter';

export default instance => {
  instance.attachEvent('onAfterTaskAdd', (id, task) => {
    Filter.onAfterTaskAdd(id, task);
  });
};
